/** @jsxImportSource theme-ui */
import React, { useState } from 'react';
import { jsx, Flex } from 'theme-ui';
import { validate, subscribe } from './hsAPI';
import ReCAPTCHA from 'react-google-recaptcha';
import { Box, Button, Input, Spinner, Text } from '@theme-ui/components';

const ShowProcessing = () => (
  <Flex sx={{ alignItems: 'center', flexDirection: 'column' }}>
    <Spinner color="white" />
  </Flex>
);

let recaptchaRef = React.createRef();

const SubscribeHeaderForm = ({ pageUrl, formName, formStyle }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [hasError, setHasError] = useState(false);
  const [message, setMessage] = useState('');
  const [processing, setProcessing] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    setHasError(false);
    setProcessing(true);
    setMessage('');

    const error = validate(email);
    setEmailError(error);
    if (error) {
      setProcessing(false);
      return;
    }

    if (recaptchaRef && recaptchaRef.current) {
      let captcha = '';
      recaptchaRef.current.reset();
      captcha = await recaptchaRef.current.executeAsync();
      const formData = {
        email,
        form_name: formName,
        captcha,
        invisible_recaptcha: true,
        page_name: document.title,
        page_url: pageUrl,
      }
      if (captcha) {
        subscribe(
          formData,
          (response) => {
            setProcessing(false);
            setMessage('Thank you for subscribing!');
          },
          (error) => {
            setProcessing(false);
            if (
              error.response &&
              error.response.status == 400 &&
              error.response.data.invalid_email
            ) {
              setEmailError(error.response.data.invalid_email);
            } else {
              setHasError(true);
            }
          }
        );
      } else {
        setProcessing(false);
        setHasError(true);
      }
    } else {
      setProcessing(false);
      setHasError(true);
    }
  };

  return (
    <Box
      sx={{ textAlign: 'center' }}
      className="hs-form-container">
      {!message ? (
        <Flex
          as="form"
          sx={formStyle}
          onSubmit={handleClick}
          className="hs-form">
          <Input
            name="email"
            type="email"
            value={email}
            placeholder="Enter your email"
            onChange={(e) => setEmail(e.target.value)}
            required
            className="hs-email hs-subscribe-input"
          />
          <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            sitekey={process.env.GATSBY_INVISIBLE_RE_CAPTCHA_SITE_KEY}
            badge='bottomleft'
          />
          <Button disabled={processing} className="hs-action hs-subscribe-btn">
            SUBSCRIBE
          </Button>
        </Flex>
      ) : (
        <Text className="hs-success">
          {message}
        </Text>
      )}
      <Box
        sx={{ textAlign: 'center', color: 'white', my: 2}}
        className="hs-message">
        {processing ? <ShowProcessing /> : null}
        {emailError ? <b>{emailError}</b> : null}
        {hasError ? <b>Sorry, some error seems to have occurred!</b> : null}
      </Box>
    </Box>
  );
};

export default SubscribeHeaderForm;
